import { BaseEntityRestService } from '@processpuzzle/base-entity';
import { ApplicationProperty } from '@processpuzzle/base-widget';
import { CustomApplicationPropertyMapper } from './custom-application-property.mapper';

/**
 * The application properties of the organization in the URL, read from and written to **this application's own
 * backend** rather than to the testbed's json-server.
 *
 * Core's `ApplicationPropertyService` resolves `THIRD_PARTY_ROOT`, which in the testbed frontend is the json-server
 * mock it is meant to be, and which this application does not configure — so core's store throws `NG0201` the
 * moment a header with a like button renders, and every page that shows one stops rendering the rest of its texts.
 *
 * `BACKEND_SERVICE_ROOT` is the key because it is always present and `withOrganizationRoots` has already made it
 * `<host>/organizations/<orgKey>` before bootstrap, so the request goes to `…/organizations/<orgKey>/application-properties`
 * and a like on one organization's application is not seen on another's.
 *
 * **Construct this inside an injection context.** `BaseEntityRestService` reads `RUNTIME_CONFIGURATION` and
 * `HttpClient` in field initialisers, so `new CustomApplicationPropertyService(...)` outside one throws. The provider
 * in `app.config.ts` uses `useFactory`, which runs in one.
 */
export class CustomApplicationPropertyService extends BaseEntityRestService<ApplicationProperty> {
  constructor(protected override entityMapper: CustomApplicationPropertyMapper) {
    super(entityMapper, 'BACKEND_SERVICE_ROOT', 'application-properties');
  }
}
